import React from "react";
import { ModalAlertStyled } from "./ModalAlertStyled";
import { useSelector } from "react-redux";
import { getModalData } from "../../slice/selectors";
import Typography from "../../../../UI/Typography";
import { TYPOGRAPHY_TYPE } from "../../../../entities/Typography";

const ModalAlert: React.FC = () => {
  const { content } = useSelector(getModalData);
  const { description = "" } = content;
  return (
    <ModalAlertStyled>
      <Typography type={TYPOGRAPHY_TYPE.BOLD}>{description}</Typography>
    </ModalAlertStyled>
  );
};

export default ModalAlert;
